export var KEY_LEFT = 37;
export var KEY_UP = 38;
export var KEY_RIGHT = 39;
export var KEY_DOWN = 40;
export var KEY_ENTER = 13;
export var KEY_ESCAPE = 27;
export var KEY_SPACE = 32;
export var KEY_TAB = 9;
//# sourceMappingURL=key.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ionic-angular/platform/key.js
// module id = 19
// module chunks = 7